module.exports = __webpack_public_path__ + "img/administration.d8744da3.svg";